import {FunctionNameLiteral} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaDefinitions';

export class FunctionUtil
{
    public static parseFunctionName(functionFullName:string):FunctionNameLiteral
    {
        const dotIndex = functionFullName.lastIndexOf('.');

        if( dotIndex >= 0 )
        {
            const namespace = functionFullName.slice(0, dotIndex);
            const name = functionFullName.slice(dotIndex + 1);

            return new FunctionNameLiteral(namespace, name);
        }

        return new FunctionNameLiteral('default-ns', functionFullName);
    }
}
